import { render, staticRenderFns } from "./BoxTagPanel.vue?vue&type=template&id=49b75997&scoped=true"
import script from "./BoxTagPanel.vue?vue&type=script&lang=js"
export * from "./BoxTagPanel.vue?vue&type=script&lang=js"
import style0 from "./BoxTagPanel.vue?vue&type=style&index=0&id=49b75997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b75997",
  null
  
)

export default component.exports